'use strict';
var core = require('core/product/detail');
var debounce = require('lodash/debounce');

core.updateAttribute = function () {
  $('body').on('product:afterAttributeSelect', function (e, response) {
      if ($('.product-detail>.bundle-items').length) {
          response.container.data('pid', response.data.product.id);
          response.container.find('.product-id').text(response.data.product.id.split(" ")[0]);
      } else if ($('.product-set-detail').eq(0)) {
          response.container.data('pid', response.data.product.id);
          response.container.find('.product-id').text(response.data.product.id.split(" ")[0]);
      } else {
          $('.product-id').text(response.data.product.id.split(" ")[0]);
          $('.product-detail:not(".bundle-item")').data('pid', response.data.product.id);
      }
  });
}

module.exports = core;